import {
    Button,
    CardContent,
    Grid,
    IconButton,
    makeStyles,
    Modal,
    Paper,
    Typography
} from "@material-ui/core";
import React, { useContext } from "react";
import { Close } from "@material-ui/icons";
import AppState from '../../context/AppContext';

const useStyles = makeStyles((theme) => ({
    input: {
        minWidth: '360px',
        backgroundColor: 'white',
        color: 'black',
        '& .MuiFormHelperText-root': {
            color: 'black',
        },
        '& .Mui-error': {
            color: 'black',
        },
    },
    errorText: {
        color: 'white',
        fontSize: '14px',
        fontWeight: 'bold',
    },
    card: {
        marginTop: '20px',
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        margin: 'auto',
        maxWidth: '420px',
        padding: theme.spacing(2),
    },
    typography: {
        marginTop: theme.spacing(2),
        alignItems: 'center',
        justifyContent: 'center',
    },
    cardModal: {
        width: '100%',
    },
    closeButton: {
        float: 'right'
    },
}));

const DeleteChildGift = ( props ) => {
    const classes = useStyles();
    const context = useContext( AppState );
    const childGift = context.store.currentGift;
    const handleClose = () => {
        props.handleClose();
    };
    const onSubmit = () => {
        context.store.children.map(child => {
            if (child.list.includes(context.store.currentGift)) {
                const index = child.list.findIndex(gift => gift === context.store.currentGift)
                child.list.splice(index, 1)
            }
        return undefined})
         context.store.deleteGift = false;
        context.setStore({
            ...context.store,
        })
        handleClose();
    };

    return (
        <Modal open={props.open} className={classes.modal}>
            <Paper className={classes.paper}>
                <IconButton className={classes.closeButton} onClick={handleClose}>
                    <Close/>
                </IconButton>
                <Paper className={classes.card}>
                    <Typography variant="h5">Delete Child Gift</Typography>
                    <CardContent>
                        <Typography variant="body1">
                            Are you sure you want to delete the gift "{childGift}"?
                        </Typography>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <Button
                                    fullWidth
                                    variant="contained"
                                    color="secondary"
                                    onClick={onSubmit}
                                >
                                    Delete
                                </Button>
                            </Grid>
                            <Grid item xs={6}>
                                <Button
                                    fullWidth
                                    variant="outlined"
                                    color="primary"
                                    onClick={handleClose}
                                >
                                    Cancel
                                </Button>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Paper>
            </Paper>
        </Modal>
    );
};
export default DeleteChildGift;
